export function findIntersection(segment1:Point[], segment2:Point[]) {
    var P1 = segment1[0], P2 = segment1[1], P3 = segment2[0], P4 = segment2[1];
    
    

    var x =
      ((P1.x * P2.y - P2.x * P1.y) * (P3.x - P4.x) -
        (P1.x - P2.x) * (P3.x * P4.y - P3.y * P4.x)) /
      ((P1.x - P2.x) * (P3.y - P4.y) - (P1.y - P2.y) * (P3.x - P4.x));
    var y =
      ((P1.x * P2.y - P2.x * P1.y) * (P3.y - P4.y) -
        (P1.y - P2.y) * (P3.x * P4.y - P3.y * P4.x)) /
      ((P1.x - P2.x) * (P3.y - P4.y) - (P1.y - P2.y) * (P3.x - P4.x));
    return { x: Number(x.toPrecision(8)), y: Number(y.toPrecision(8)) };
  }
  
  export function isPointBetween(p:Point, a:Point, b:Point) {
    return ((a.x <= p.x && p.x <= b.x) || (a.x >= p.x && p.x >= b.x)) && ((a.y <= p.y && p.y <= b.y) || (a.y >= p.y && p.y >= b.y));
  }
  
  export function findSegmentIntersection(segment1:Point[], segment2:Point[]) {
    var i1 = findIntersection(segment1,segment2);


    var P1 = segment1[0], P2 = segment1[1], P3 = segment2[0], P4 = segment2[1];
    const isIntersected = isPointBetween(i1, P1, P2) && isPointBetween(i1, P3, P4);

    var p1 = isPointBetween(i1, P1, P2);
    var p2 = isPointBetween(i1, P3, P4);

    return isIntersected ? i1 : false;
  }
  
  export function isSegmentIntersected(segment1:Point[], segment2:Point[]) {

    var i1 = findIntersection(segment1,segment2);
    var P1 = segment1[0], P2 = segment1[1], P3 = segment2[0], P4 = segment2[1];

  

    return isPointBetween(i1, P1, P2) && isPointBetween(i1, P3, P4);

  }
  

  export function  findAllIntersections(nSegmentedline1:Segment[], nSegmentedline2:Segment[],reversed:boolean = false ):(Point  | boolean)[]
  {
    let allSegmentIntersectionInformation:(Point  | boolean)[] = [];

    if(reversed)
    {
        nSegmentedline1.reverse();
        nSegmentedline2.reverse();
    }

    for(let index = 0;index<nSegmentedline1.length;index++)
    {
   
       let segment1:Point[] = [ nSegmentedline1[index].s, nSegmentedline1[index].e ];
       let segment2:Point[] = [ nSegmentedline2[index].s, nSegmentedline2[index].e ];
       
       let cross = findSegmentIntersection(segment1,segment2) as (Point | boolean);
       allSegmentIntersectionInformation.push(cross)
    }
    return allSegmentIntersectionInformation;
  }

  export function  findAllIntersectionsReversedWithCrossDirection(nSegmentedline1:Segment[], nSegmentedline2:Segment[] ):PointDirection[]
  {
    let allSegmentIntersectionInformation:PointDirection[] = [];
   
        nSegmentedline1.reverse();
        nSegmentedline2.reverse();
 

    for(let index = 0;index<nSegmentedline1.length;index++)
    {
   
       let segment1:Point[] = [ nSegmentedline1[index].s, nSegmentedline1[index].e ];

       let segment1N:Point[] = [ nSegmentedline1[index+1].s, nSegmentedline1[index+1].e ];

       let segment2:Point[] = [ nSegmentedline2[index].s, nSegmentedline2[index].e ];

        let crossdirection = "N/A";
        if(segment1[1].y > segment2[1].y &&  segment1N[1].y < segment1[1].y)
        {
            crossdirection = "over";
        }

        if(segment1[1].y < segment2[1].y &&  segment1N[1].y > segment1[1].y)
        {
            crossdirection = "under";
        }



       let cross = findSegmentIntersection(segment1,segment2) as (Point | boolean);
       allSegmentIntersectionInformation.push({point:cross, direction:crossdirection})
    }
    return allSegmentIntersectionInformation;
  }

  export function  findFirstIntersectionsReversedWithCrossDirection(nSegmentedline1:Segment[], nSegmentedline2:Segment[] ):PointDirection[] | boolean
  {
    let allSegmentIntersectionInformation:PointDirection[] = [];
   
        nSegmentedline1.reverse();
        nSegmentedline2.reverse();
 

    for(let index = 0;index<nSegmentedline1.length;index++)
    {
   
        if(index == (nSegmentedline1.length-1))
        {
            return false;
        }

       let segment1:Point[] = [ nSegmentedline1[index].s, nSegmentedline1[index].e ];
       let segment1N:Point[] = [ nSegmentedline1[index+1].s, nSegmentedline1[index+1].e ];
       let segment2:Point[] = [ nSegmentedline2[index].s, nSegmentedline2[index].e ];

        let cross = findSegmentIntersection(segment1,segment2) as (Point | boolean);

        let crossdirection = "N/A";

        if( cross!=false )
        {

        //  if(segment1[1].y > segment2[1].y &&  segment1N[0].y < segment1[1].y && segment1N[0].y < (cross as Point).y)
          if(segment2[1].y < segment1[1].y &&  segment1[0].y < segment2[0].y)
          {
              crossdirection = "over";
          }

          //if(segment2[1].y > segment1[1].y &&  segment1N[0].y > segment1[1].y && segment1N[0].y > (cross as Point).y)
          if(segment2[1].y > segment1[1].y &&  segment1[0].y > segment2[0].y)
          {
              crossdirection = "under";
          }

       }

      

       



       allSegmentIntersectionInformation.push({point:cross, direction:crossdirection});

        if(cross!=false && crossdirection!="N/A")
        {
            return allSegmentIntersectionInformation;
        }


    }

    return false;
  }



  export interface PointDirection
  {
      point:(Point | boolean);
      direction:string;
  }



export interface Point
{
    x:number;
    y:number
}

export interface Segment
{
    s:Point
    e:Point
}




// let segment1:Point[] = [{x:4,y:1},{x:5,y:2}];
// let segment2:Point[] = [{x:4,y:3.5},{x:4,y:2.5}];

// let intersect = findSegmentIntersection(segment1,segment2);

// console.log(intersect);


// let nSegmentedline1:Segment[] = [
//                                   {s:{x:1,y:1},e:{x:2,y:2}},
//                                   {s:{x:2,y:2},e:{x:3,y:1.5}},
//                                   {s:{x:3,y:1.5},e:{x:4,y:1}},
//                                   {s:{x:4,y:1},e:{x:5,y:1.5}},
//                                   {s:{x:5,y:1.5},e:{x:6,y:0.5}},
//                                   {s:{x:6,y:0.5},e:{x:7,y:1}},
//                                   {s:{x:7,y:1},e:{x:8,y:1.5}},
//                                   {s:{x:8,y:1.5},e:{x:9,y:2}},
//                                 ]

// let nSegmentedline2:Segment[] = [
//                                   {s:{x:1,y:1.7},e:{x:2,y:1.7}},
//                                   {s:{x:2,y:1.7},e:{x:3,y:1.7}},
//                                   {s:{x:3,y:1.7},e:{x:4,y:1.7}},
//                                   {s:{x:4,y:1.7},e:{x:5,y:1.7}},
//                                   {s:{x:5,y:1.7},e:{x:6,y:1.7}},
//                                   {s:{x:6,y:1.7},e:{x:7,y:1.7}},
//                                   {s:{x:7,y:1.7},e:{x:8,y:1.7}},
//                                   {s:{x:8,y:1.7},e:{x:9,y:1.7}},
//                                 ]

// // let allSegmentIntersectionInformation:(Point  | boolean)[] = [];
// // allSegmentIntersectionInformation = findAllIntersections(nSegmentedline1,nSegmentedline2)
// // console.log(allSegmentIntersectionInformation); 

// // let allSegmentRevIntersectionInformation:PointDirection[] = [];
// // allSegmentRevIntersectionInformation = findAllIntersectionsReversedWithCrossDirection(nSegmentedline1,nSegmentedline2)
// // console.log(allSegmentRevIntersectionInformation); 

// let firstSegmentRevIntersectionInformation:PointDirection[] | boolean = [];
// firstSegmentRevIntersectionInformation = findFirstIntersectionsReversedWithCrossDirection(nSegmentedline1,nSegmentedline2)
// console.log(firstSegmentRevIntersectionInformation); 
